import { AppProviders } from 'Features/App/AppProviders'
import { AppRoutes } from 'Features/App/routes'
import { MuiXLicense } from 'Features/App/MuiXLicence'

export const App = () => {
  return (
    <AppProviders>
      <MuiXLicense />
      <AppRoutes />
    </AppProviders>
  )
}
